
<template>
  <div class="main-text" :class="size ? 'custom-size' : ''" :style="style">
      <slot></slot>                
  </div>
</template>

<script>
export default {

    name: 'UiText',

    props: {
      size: {
        type: String,
        default: null
      },
      color: {
        type: String,
        default: '#000000'
      }
    },

    computed: {
      style () {
        return {
          '--color': this.color,
          '--size': this.size
        }
      }
    },
}
</script>

<style>
  .main-text{
    font-family: 'Helvetica';
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 131.5%;
    
    color: var(--color);
  }
  .custom-size{
    size: var(--size) !important;
  }
  @media (max-width: 1650px) {
    .main-text{
      font-size: 20px;
    }
  }
  @media (max-width: 1350px) {
    .main-text{
      font-size: 18px;
    }
  }
  @media (max-width: 850px) {
    .main-text{
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// UIText.vue?71299a5f